module.exports = __webpack_public_path__ + "static/new1-fc3fec765c6dfb87010d75ebda14c5b6.jpeg";